import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import MembershipSortingSelectBox from '../../../Component/MemberComponent/MembershipSortingSelectBox';

import { ReactComponent as SortingButtonSvg } from '../../../image/SortingButton.svg';

export default function PartnerColumnView(props) {
  const {
    selectedMembership,
    setSelectedMembership,
    genderSort,
    setGenderSort,
    birthSort,
    setBirthSort,
    startSort,
    setStartSort,
    endSort,
    setEndSort
  } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  // 성별 정렬 버튼 클릭시 //
  function onClickGenderSort() {
    setBirthSort('normal');
    setStartSort('normal');
    setEndSort('normal');

    if (genderSort === 'normal' || genderSort === 'desc') setGenderSort('asc');
    else if (genderSort === 'asc') setGenderSort('desc');
  }

  // 생년월일 정렬 버튼 클릭시 //
  function onClickBirthSort() {
    setGenderSort('normal');
    setStartSort('normal');
    setEndSort('normal');

    if (birthSort === 'normal' || birthSort === 'desc') setBirthSort('asc');
    else if (birthSort === 'asc') setBirthSort('desc');
  }

  // 시작일 정렬 버튼 클릭시 //
  function onClickStartSort() {
    setGenderSort('normal');
    setBirthSort('normal');
    setEndSort('normal');

    if (startSort === 'normal' || startSort === 'desc') setStartSort('asc');
    else if (startSort === 'asc') setStartSort('desc');
  }

  // 종료일 정렬 버튼 클릭시 //
  function onClickEndSort() {
    setGenderSort('normal');
    setBirthSort('normal');
    setStartSort('normal');

    if (endSort === 'normal' || endSort === 'desc') setEndSort('asc');
    else if (endSort === 'asc') setEndSort('desc');
  }

  return (
    <TopLevelWrapper>
      <Column style={{marginLeft: '20px'}} width={64}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colName')}</Text>
      </Column>
      <SortingWrapper width={72}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colGender')}</Text>
        <SortingButton $sort={genderSort} onClick={() => onClickGenderSort()}/>
      </SortingWrapper>
      <SortingWrapper width={106}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colBirth')}</Text>
        <SortingButton $sort={birthSort} onClick={() => onClickBirthSort()}/>
      </SortingWrapper>
      <Column width={106}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colPhone')}</Text>
      </Column>
      <SortingWrapper width={234}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colMembership')}</Text>
        <MembershipSortingSelectBox
          value={selectedMembership}
          setValue={setSelectedMembership} />
      </SortingWrapper>
      <SortingWrapper width={86}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colStartDate')}</Text>
        <SortingButton $sort={startSort} onClick={() => onClickStartSort()}/>
      </SortingWrapper>
      <SortingWrapper width={86}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colEndDate')}</Text>
        <SortingButton $sort={endSort} onClick={() => onClickEndSort()}/>
      </SortingWrapper>
      <Column width={80}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('partnerGym.colPartnerGym')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 1020px;

  margin-top: 34px;

  gap: 8px;
`;

const SortingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  gap: 4px;

  overflow: hidden;
`;

const SortingButton = styled(SortingButtonSvg)`
  margin-left: 4px;
  flex-shrink: 0;

  width: 20px;
  height: 20px;

  transform: ${props => props.$sort === 'asc' ? 'rotate(180deg)' : 'none'};

  & rect {
    fill: ${props => props.$sort !== 'normal' ? props.theme.primary : props.theme.buttonFill};
    transition: fill 0.3s ease-in-out;
  }

  & path:first-of-type {
    fill: ${props => props.$sort !== 'normal' ? props.theme.subBackground : props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  & path:last-of-type {
    fill: ${props => props.$sort !== 'normal' ? props.theme.subBackground : props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;
